enum PartnerType {
  Household,
  Business,
}

export default PartnerType;
